import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import files from './review/fileReviewReducers'
import fileRequests from './review/fileReviewRequestReducers'

import * as h2Api from '../h2Api'
import {
  APPROVE_FILE_REVIEW,
  REQUEST_FILE_REVIEW_REQ
} from '../actions/review/reviewActions'

const initialReviewModel = {
  contactAddress: null,
  contactType: 1,
  comments: null
}
const initialApprovalModel = {
  comments: null,
  approvedBy: null
}
const review = combineReducers({
  files,
  fileRequests,
  fileRequestsRequest: h2Api.restReducer(REQUEST_FILE_REVIEW_REQ),
  fileApprovalRequest: h2Api.restReducer(APPROVE_FILE_REVIEW),
  requestFileReviewForm: modelReducer('review.requestFileReviewForm', initialReviewModel),
  requestFileApprovalForm: modelReducer(
    'review.requestFileApprovalForm',
    initialApprovalModel
  ),
  forms: formReducer('review', {
    requestFileReviewForm: initialReviewModel,
    requestFileApprovalForm: initialApprovalModel
  })
})

export default review
